import { render, staticRenderFns } from "./detail-form1.vue?vue&type=template&id=3722c889&scoped=true&"
import script from "./detail-form1.vue?vue&type=script&lang=js&"
export * from "./detail-form1.vue?vue&type=script&lang=js&"
import style0 from "./detail-form1.vue?vue&type=style&index=0&id=3722c889&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3722c889",
  null
  
)

component.options.__file = "detail-form1.vue"
export default component.exports